import { flow, Instance, SnapshotIn, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { TransferRequest } from './models/TransferRequest';
import { getEnvironment } from './utils';

const identifier = 'transferRequestId';

export const TransferRequestStore = types
  .compose(
    getBaseStore<Instance<typeof TransferRequest>, Instance<typeof TransferRequest>>(TransferRequest, identifier, 'transferRequest'),
    types.model('TransferRequestStore', {}),
  )
  .actions((self) => {
    const env = getEnvironment(self);

    const saveTransferRequest = flow(function*(transferRequest: Instance<typeof TransferRequest>) {
      const res = yield self.saveElement(transferRequest);
    });

    const loadActiveList = flow(function*(options?: any) {
      const storeName = self['$treenode']['_subpath'];
      console.log('START LOADING STORE ' + storeName + ' [' + new Date() + ']');
      const res: any = yield env.api.get('TransferRequest/active', {
        ...options,
        params: { ...(options || {}).params },
      });
      let resultIds;
      if (res !== null) {
        self.setDatasFromArray(res!);
        resultIds = res!.map((r) => r[identifier]);
      }
      const result = self.dataList.filter((d) => resultIds.indexOf(d[identifier]) >= 0);
      return result;
    });

    return {
      // afterAttach: flow(function*() {
      //   yield self.loadList();
      // }),
      saveTransferRequest,
      loadActiveList,
    };
  });

export type transferRequestStoreType = Instance<typeof TransferRequestStore>;
